import React from 'react'
import '../Styles/servicios.css'

const servicios = ({title, text, imagen}) => {
    return ( 
        <div className="servicios">
            <img src={imagen} alt=""/>
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
     );
}
 
export default servicios;